import { useState } from "react";
import {  motion } from 'framer-motion';


export default function TabBar({
    namelist = [],
    initialTab = 0,
    textStyle={
        fontSize : "14px", //text-base
        letterSpacing : "0.1em", // tracking-wider
        fontWeight: 600, //semibold
    },
    indicatorSize = 8,
    getCurrentTabCallback
}){

    const [hovering, setHovering] = useState(false);
    const [currentTab, setCurrentTab] = useState(initialTab);

    const tabItemClass = `
        flex
        flex-col
        items-center
        text-body-text-light
        dark:text-body-text-dark
        cursor-pointer
    `

    const bulletClass = `
        bg-body-text-light
        dark:bg-body-text-dark
        rounded-full
        mt-1
    `;


    const nameItems = (arr) => {
        let outputArr = [];


        for(let i = 0; i < arr.length; i++){
            const bulletVariants = {
                initial: {
                    scale: (currentTab === i) && !hovering? 1:0
                },
                animate: {
                    scale: 1
                }
            }

            outputArr.push(
                <motion.div 
                    key={i}
                    initial={{
                        opacity: 0,
                        translateY: "50%"
                    }}
                    whileInView={{
                        opacity: 1,
                        translateY: 0,
                    }}
                    transition={{
                        delay: i * 0.1,
                        duration: 0.5,
                        ease: "backInOut"
                    }}
                    viewport={{
                        once: true,
                        amount: 1,
                    }}

                >



                    <motion.div
                        initial="initial"
                        animate="initial"
                        whileHover="animate"
                        onHoverStart={ () => setHovering(true) }
                        onHoverEnd={ () => setHovering(false) }
                        onClick={ () => {
                            setCurrentTab(i)
                            getCurrentTabCallback(i)
                        }}
                    >
                        <li className={tabItemClass}>
                            <span
                                style={textStyle}
                            >
                                {
                                    arr[i]
                                }
                            </span>
                            <motion.div
                                initial={{
                                    scale: 0
                                }}
                                animate={{
                                    scale: (currentTab === i) && !hovering? 1:0,
                                }}
                                exit={{
                                    scale: 0
                                }}
                                transition={{
                                    ease: "backInOut",
                                    duration: 0.6,
                                }}
                                variants={bulletVariants}
                                className={bulletClass}
                                style={{
                                    height: `${indicatorSize}px`,
                                    width: `${indicatorSize}px`,
                                }}
                            >

                            </motion.div>
                        </li>
                        
                    </motion.div>







                </motion.div>
            );
            
        }

        return outputArr;
    }

    return (

        <div>
            <ul className="flex gap-x-5 sm:gap-x-8 md:gap-x-16 lg:gap-x-32 justify-center">
                {
                    nameItems(namelist)
                }
            </ul>
        </div>
    );
}